import React from "react";
import withStyles from "@material-ui/styles/withStyles";
import Loader from "storybookComponents/Loader";
import { getPropertyId } from "common";
import EnableBox from "./EnableBox";
import Approvers from "./Approvers";
import ApprovedAgents from "./ApprovedAgents";
import { saveSetting } from "../apis";
import UserContext from "context/UserContext";
import styles from "../styles";

const ApprovalProcess = ({
  classes,
  approverSettings,
  updateEventsSettings,
  showNotification,
  orgLevel,
}) => {
  const { subOrgDetails } = React.useContext(UserContext);
  const [enabled, setEnabled] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const [approvers, setApprovers] = React.useState([]);
  const [approvedAgents, setApprovedAgents] = React.useState([]);
  const [inputData, setInputData] = React.useState(null);

  const handleSwitch = () => {
    const temp = enabled;
    setEnabled(!temp);
    saveSetting({
      ...inputData,
      approvalRequired: !enabled,
    })
      .then((data) => {
        updateEventsSettings(data);
        setIsLoading(false);
        showNotification("Approval process is updated!", "success");
        setEnabled(!temp);
      })
      .catch((err) => {
        showNotification(err?.message || "Something went wrong!", "error");
        setIsLoading(false);
        setEnabled(temp);
      });
  };

  const handleSave = (updatedData) => {
    setIsLoading(true);
    saveSetting({
      ...inputData,
      ...updatedData,
    })
      .then((data) => {
        updateEventsSettings(data);
        setIsLoading(false);
        showNotification("Approval process is updated!", "success");
      })
      .catch((err) => {
        showNotification(err?.message || "Something went wrong!", "error");
        setIsLoading(false);
      });
  };

  React.useEffect(() => {
    if (!!approverSettings) {
      setIsLoading(false);
      setEnabled(approverSettings.approvalRequired);
      setApprovers(approverSettings.approverEmails);
      setApprovedAgents(approverSettings.agentApprovalEmails);

      let inputData = {
        orgId: subOrgDetails.org.id,
        approvalRequired: approverSettings.approvalRequired,
        approverEmails: approverSettings.approverEmails,
        agentApprovalEmails: approverSettings.agentApprovalEmails,
        emailLimits: approverSettings.emailLimits,
      };
      if (!orgLevel) inputData["propertyId"] = getPropertyId();
      setInputData(inputData);
    }
  }, [approverSettings]);

  return (
    <div className={classes.contentBox}>
      {isLoading && <Loader />}
      {!isLoading && (
        <>
          <EnableBox classes={classes} enabled={enabled} onSwitch={handleSwitch} event />
          {enabled && (
            <>
              <div className={classes.expansion}>
                <Approvers classes={classes} approversData={approvers} onSave={handleSave} event />
              </div>
              <ApprovedAgents
                classes={classes}
                approvedAgentsData={approvedAgents}
                onSave={handleSave}
                event
              />
            </>
          )}
        </>
      )}
    </div>
  );
};

export default withStyles(styles)(ApprovalProcess);
